import axios from "axios";
import { url } from "./url";
import { config } from "./token";

const api = axios.create({
  baseURL: `${url}/user`,
});

export const checkTestUser = (phone) => api.get(`/isTestUser/${phone}`);

export const signup = (payload) => api.post(`/signup`, payload);
export const preSignup = (payload) => api.post(`/preSignup`, payload);
export const preSignin = (phone) => api.get(`/preSignin/${phone}`);
export const signin = (payload) => api.post(`/signin`, payload);
export const resendCode = (phone) => api.get(`/resendCode/${phone}`);

export const getMyProfile = () => api.get(`/myProfile`, config());
export const getMySubscriptions = () => api.get(`/mySubscriptions`, config());
export const editSubscriptions = (payload) =>
  api.put(`/editSubscriptions`, payload, config());
export const getMyNotifications = () => api.get(`/myNotifications`, config());
export const getMoreSubscriptions = (payload) =>
  api.post(`/moreNotifications`, payload, config());
export const deleteAccount = () => api.post(`/delete`, null, config());
const userApi = {
  checkTestUser,
  signup,
  preSignup,
  preSignin,
  signin,
  resendCode,
  getMyProfile,
  getMySubscriptions,
  editSubscriptions,
  getMyNotifications,
  getMoreSubscriptions,
  deleteAccount,
};

export default userApi;
